import { render, staticRenderFns } from "./fixedAssetsCount.vue?vue&type=template&id=b267ab94&scoped=true"
import script from "./fixedAssetsCount.vue?vue&type=script&lang=js"
export * from "./fixedAssetsCount.vue?vue&type=script&lang=js"
import style0 from "./fixedAssetsCount.vue?vue&type=style&index=0&id=b267ab94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b267ab94",
  null
  
)

export default component.exports